export default "__VITE_ASSET__DeCPX81w__"